import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

// Locked drop date: August 14
const TARGET = new Date("2026-08-14T00:00:00").getTime();

const getRemaining = () => {
  const diff = Math.max(0, TARGET - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    mins: Math.floor((diff % 3600000) / 60000),
    secs: Math.floor((diff % 60000) / 1000),
    done: diff === 0,
  };
};

const pad = (n) => String(n).padStart(2, "0");

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center" data-testid={`countdown-${label.toLowerCase()}`}>
    <span className="font-serif-display text-3xl sm:text-4xl md:text-5xl leading-none tabular-nums">{pad(value)}</span>
    <span className="label mt-1 opacity-70">{label}</span>
  </div>
);

export const DropCountdown = ({ light = false }) => {
  const [t, setT] = useState(getRemaining());
  useEffect(() => {
    const id = setInterval(() => setT(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  const color = light ? "text-[#EDEEF1]" : "text-[#0B0E14]";

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.1, duration: 0.8 }}
      data-testid="drop-countdown"
      className={`inline-flex flex-col ${color}`}
    >
      <div className="flex items-center gap-2 label mb-3">
        <span className="w-2 h-2 bg-volt inline-block animate-pulse" /> Drop 002 lands Aug 14
      </div>
      {t.done ? (
        <span className="font-serif-display text-3xl volt">It's live — shop now.</span>
      ) : (
        <div className="flex items-start gap-4 sm:gap-6">
          <Unit value={t.days} label="Days" />
          <span className="font-serif-display text-3xl sm:text-4xl md:text-5xl leading-none opacity-40">:</span>
          <Unit value={t.hours} label="Hrs" />
          <span className="font-serif-display text-3xl sm:text-4xl md:text-5xl leading-none opacity-40">:</span>
          <Unit value={t.mins} label="Min" />
          <span className="font-serif-display text-3xl sm:text-4xl md:text-5xl leading-none opacity-40">:</span>
          <Unit value={t.secs} label="Sec" />
        </div>
      )}
    </motion.div>
  );
};
